import React, { useState, useEffect } from 'react';
import clsx from "clsx";
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  makeStyles,
  CardContent,
  Grid
} from '@material-ui/core';


import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';

import Chargemter from "./chargemeter";


import firebase from '../../Firebase';
import { getDatabase, ref, onValue, get, child } from 'firebase/database';

import VGICapacities from './components/VGICapacities';

import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';


ChartJS.register(ArcElement, Tooltip);



const drawInnerText = (chart, text) => {
  let ctx = chart.ctx;
  ctx.restore();
  // const fontSize = (chart.height / 114).toFixed(2);
  // ctx.font = fontSize + 'em sans-serif';
  ctx.font = 'bold 0.7em sans-serif';
  // ctx.font = 'bold 0.6em Noto Sans';
  // ctx.font = '0.6em Noto Sans';
  // ctx.textBaseline = 'middle';
  ctx.textBaseline = 'bottom';
  const dataArrValues = chart.config._config.data.datasets[0].data;

  let sub_text =
  (chart.tooltip._active && chart.tooltip._active.length > 0)
      ? `${Math.round(
        (dataArrValues[chart.tooltip._active[0].datasetIndex] /
          dataArrValues.reduce((a, b) => a + b)) *
        100
      )}%`
      : `${Math.round(
        (dataArrValues[0] / dataArrValues.reduce((a, b) => a + b)) * 100
      )}%`;

  //충전기 식별자
  let textX = Math.round((chart.width - ctx.measureText(text).width) / 2);
  // let textY = chart.height / 2 + chart.legend.height / 2;
  // let textY = chart.height / 2 + chart.legend.height / 10;
  let textY = chart.height / 2 + 10;
  ctx.fillText(text, textX, textY);

  //사용률 표시
  ctx.font = '0.7em sans-serif';
  textX = Math.round((chart.width - ctx.measureText(sub_text).width) / 2);
  ctx.fillText(sub_text, textX, textY + 20);
  ctx.fillStyle = '#000';

  ctx.save();
};

//https://firebase.google.com/docs/database/web/read-and-write?hl=ko




const InstantaneousCharge = props => {

  const { className, user, ...rest } = props;
  const classes = useStyles();

  const [lCAmountRatio, setLCAmountRatio] = useState(0);
  const [maxProfile, setMaxProfile] = useState(0);
  const [viewData, setViewData] = useState([]);


  const database = getDatabase();
  const dbRef = ref(database);


  const makeChargerData = (chargerId, charging, others) => {

    const data = {
      labels: ["charge ratio", "avail ratio"],
      datasets: [{
        data: [charging, others],
        backgroundColor: [
          'rgb(116, 188, 129)',
          'lightgray',
        ],
        hoverOffset: 4,
        borderWidth: 1,
        circumference: 180,
        rotation: 270,
        cutout: '70%',
      }]
    };

    const opt = {
      type: 'doughnut',
      data: data,
      responsive: true,

      title: {
        display: true,
        // text: 'CHGR_' + String(i + 1).padStart(2, '0'),
        text: chargerId,
      },

      plugins: {
        legend: {
          display: false,
        },
      },
    };

    return {data, opt};
  }



  const makeSampleData2 = () => {

    onValue(child(dbRef, 'simu/instantaneous/chgr'), (snapshot) => {
      let listData = [];
      snapshot.forEach(function (childSnapshot) {
        const childData = makeChargerData(childSnapshot.val().chgr_id, childSnapshot.val().charging, childSnapshot.val().others);
        listData.push({ data:childData.data, opt:childData.opt });
      });
      setViewData(listData);
    });
  }


  useEffect(() => {
    onValue(child(dbRef, 'simu/instantaneous/lc'), (snapshot) => {
      snapshot.forEach(function (childSnapshot) {
        if (childSnapshot.key === "total_charge_amount_ratio") {
          setLCAmountRatio( childSnapshot.val()  );
        }
        else if(childSnapshot.key === "lc_max_profile"){
          setMaxProfile( (childSnapshot.val() / 1000).toFixed(1) );
        }
      });
    });

    makeSampleData2();
  }, []);



  return (
    <div>
      <Card className={clsx(classes.root, className)} >

        <CardContent>
          <Grid container direction="column" justifyContent="space-between" spacing={0}>
            <Grid item>
              <Typography className={classes.title} color="textSecondary" gutterBottom variant="h2" align='center'>
              {i18n.t("lc_status")}
              </Typography>

              <Typography className={classes.title} color="textSecondary" variant="body1" align='center'>
              {i18n.t("max_power")}: {maxProfile}<Typography variant="caption" style={{paddingLeft:'4px'}}>[kWh]</Typography>
              </Typography>

            </Grid>
          </Grid>


          <Grid container spacing={1}  >
            <Grid container item lg={6} md={12} xs={12} direction="row" alignItems='flex-end' justifyContent='center' >
              <div className="dials">
                <Chargemter
                  id="dial5"
                  height={200}
                  maxValue={100}
                  value={lCAmountRatio}
                  title={`${i18n.t("max_power")}[%]`}
                />
              </div>
            </Grid>

            <Grid container item lg={6} md={12} xs={12} direction="row" alignItems='flex-end' justifyContent='center' >
              <VGICapacities />
            </Grid>



            {viewData.map((module, index) => (

              <Grid item lg={2} md={2} xs={2} key={module.opt.title.text}>
                <Doughnut
                  data={module.data}
                  options={module.opt}
                  plugins={[
                    {
                      beforeDraw: function (chart) {
                        drawInnerText(chart, module.opt.title.text);
                      },
                    }
                  ]}
                />
              </Grid>
            ))}

          </Grid>

        </CardContent>
      </Card>
    </div>
  );
}


InstantaneousCharge.propTypes = {
  className: PropTypes.string
};

export default InstantaneousCharge;



const useStyles = makeStyles((theme) => ({

  root: {
  },

  chartContainer: {
    // //360px 이상
    // ['@media (min-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 160,
    // },
    // //360px 이하
    // ['@media (max-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 120,
    // },
    position: 'relative'
  },



  title: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  differenceValue: {
    marginRight: theme.spacing(1),
  },
  difference: {
    // marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  labelbox: {
    margin: theme.spacing(2),
  },
  current: {
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // color: theme.palette.secondary.contrastText,
    // backgroundColor: theme.palette.secondary.main,
  },
  green: {
    color: theme.palette.success.light,
    fontWeight: 600,
  },
  red: {
    color: theme.palette.error.light,
    // color: colors.red[400],
    fontWeight: 600,
  }
}));
